var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEaPremierListingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ea-premier-listing-icon_svg__a",
    d: "M0 0h55.998v55.998H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ea-premier-listing-icon_svg__c",
    d: "M0 60h63.982V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.984 3.556)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ea-premier-listing-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-premier-listing-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.998 28c0 15.462-12.536 27.998-27.999 27.998S0 43.462 0 28 12.536 0 28 0c15.462 0 27.998 12.536 27.998 28",
    fill: "#F8D7CC",
    mask: "url(#ea-premier-listing-icon_svg__b)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ea-premier-listing-icon_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-premier-listing-icon_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    mask: "url(#ea-premier-listing-icon_svg__d)",
    d: "M24.137 12.171h4.308V1.402h-4.308z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.214 11.094h2.154V2.48h-2.154v8.615zm-2.153 2.154h6.46V.325h-6.46v12.923z",
    fill: "#020303",
    mask: "url(#ea-premier-listing-icon_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    mask: "url(#ea-premier-listing-icon_svg__d)",
    d: "M35.983 5.71L23.061 16.478v18.308h25.845V16.478z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E74A10",
    mask: "url(#ea-premier-listing-icon_svg__d)",
    d: "M32.753 33.709h6.46v-9.692h-6.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.83 32.632h4.307v-7.538h-4.308v7.538zm-2.154 2.154h8.615V22.94h-8.615v11.846z",
    fill: "#020303",
    mask: "url(#ea-premier-listing-icon_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.658 31.902l-6.334 3.004-.347.132c-.45-.8-1.214-1.33-2.279-1.33h-6.461c-1.48 0-3.732-2.153-5.516-2.153h-6.33c-2.602 0-4.928 2.131-6.238 3.351A4851.456 4851.456 0 009.06 41.02l9.9 9.91c1.617-1.618 3.523-3.22 5.176-3.22H37.06c2.017 0 4.024-.62 5.451-2.046l10.716-10.716 3.046-7.615c-1.857-1.856-6.092.128-7.615 4.57",
    fill: "#FEFEFE",
    mask: "url(#ea-premier-listing-icon_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.582 41.018l8.39 8.4c1.521-1.422 3.355-2.787 5.166-2.787H37.06c1.909 0 3.573-.613 4.69-1.73l10.56-10.559 2.628-6.573c-.356-.094-.735-.054-1.04.018-1.454.337-3.325 1.849-4.222 4.464l-.146.43-6.171 2.926c.107.42.163.873.163 1.353 0 2.533-1.573 4.287-3.823 4.287H28.445a1.077 1.077 0 110-2.154H39.7c1.548 0 1.669-1.617 1.669-2.113 0-.382-.08-2.194-1.67-2.194h-6.46c-.985 0-1.98-.553-3.032-1.137-.858-.476-1.83-1.017-2.484-1.017h-6.33c-2.218 0-4.356 1.992-5.506 3.063-1.46 1.462-4.031 4.044-5.304 5.323zm8.378 11.434L7.54 41.02l.758-.76s4.07-4.09 6.094-6.115c1.392-1.299 3.934-3.667 7-3.667h6.33c1.212 0 2.39.654 3.53 1.287.73.406 1.559.867 1.985.867H39.7c1.06 0 1.97.394 2.634 1.078l5.466-2.592c1.088-2.775 3.252-4.883 5.614-5.429 1.412-.33 2.733-.005 3.621.882l.502.502-3.39 8.478-10.874 10.874c-1.522 1.522-3.728 2.36-6.212 2.36H24.138c-1.003 0-2.49.977-4.417 2.905l-.761.762z",
    fill: "#020303",
    mask: "url(#ea-premier-listing-icon_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E74A10",
    mask: "url(#ea-premier-listing-icon_svg__d)",
    d: "M7.984 38.016l-6.461 6.462 14 14 6.46-6.462z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.046 44.478l12.476 12.476 4.938-4.938L7.984 39.539l-4.938 4.939zM15.522 60L0 44.478l7.984-7.984 15.522 15.522L15.522 60z",
    fill: "#020303",
    mask: "url(#ea-premier-listing-icon_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    mask: "url(#ea-premier-listing-icon_svg__d)",
    d: "M8.893 46.8l-2.154-2.154 1.523-1.523 2.153 2.154zM47.829 31.555h2.154V16.479h-2.154zM21.984 31.555h2.153V16.479h-2.153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E9EA",
    mask: "url(#ea-premier-listing-icon_svg__d)",
    d: "M35.983 1.402L16.6 17.555l3.231 3.231L35.983 7.863l16.154 12.923 3.23-3.23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.983 6.485l16.074 12.858 1.715-1.715L35.983 2.804 18.194 17.628l1.716 1.715L35.983 6.485zm16.233 15.744L35.983 9.243 19.75 22.229l-4.746-4.746L35.984.001l20.978 17.482-4.746 4.746z",
    fill: "#020303",
    mask: "url(#ea-premier-listing-icon_svg__d)"
  }))));
}
export default SvgEaPremierListingIcon;